import { INITIALIZE_FORM } from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default (values) => companyUsersActions[INITIALIZE_FORM](values);
